export default __webpack_public_path__ + "static/media/volkihar-slide-2.cb0da79f.jpg";